import { MyInboxDocuments } from './AdminModels/MyInboxDocuments';
import { ReferenceDataVO } from './EligibilityModels/ReferenceDataVO';
import { EnrollmentSummaryDetailsBean } from './AdminModels/EnrollmentSummaryDetailsBean';
import { ResponseObject } from './ResponseObject';
import { ActiveEnrollmentInfo } from './AdminModels/ActiveEnrollmentInfo';
import { IndividualAcct } from './AdminModels/IndividualAcct';
import { MeAndMyHouseholdTab } from 'src/app/model/AdminModels/MeAndMyHouseholdTab';
import { ApplicantInfo } from 'src/app/model/AdminModels/ApplicantInfo';
import { ExpandedMessageCenter } from './AdminModels/ExpandedMessageCenter';
import { AssistanceAcct } from './AdminModels/AssistanceAcct';
import { PersonMissingDocInfo } from './AdminModels/PersonMissingDocInfo';
import { MessageCenter } from './AdminModels/MessageCenter';
import { PersonMissingInfoListByDate } from './AdminModels/PersonMissingInfoListByDate';

export class ManageAccountModel extends ResponseObject {
	languagePref: ReferenceDataVO[];
	enrollmentSummaryDetailsBeans: Array<EnrollmentSummaryDetailsBean>;
	jsonString: string;
	isFirstDisplay: boolean = false;
	enrollmentLegendBanner: string;
	username: string;
	password: string;
	email: string;
	tempEmail: string;
	phone: string;
	addressLineOne: string;
	addressLineTwo: string;
	city: string;
	state: string;
	zip: string;
	type: string;
	lastName: string;
	authorizedAddressLineOne: string;
	preferredLanguage: string;
	questionOne: string;
	questionTwo: string;
	questionThree: string;
	languageValue: string;
	authorizedAddressLineTwo: string;
	authorizedCity: string;
	authorizedState: string;
	authorizedZip: string;
	showAR: boolean = false;
	updateAR: boolean = false;
	responsibleAdultAR: boolean = false;
	applnExist: boolean;
	loginUserId: string;
	applnAddlAttrId: number;
	language: string = "es";
	paperlessYn: string;
	paperYn: string;
	applicationStatus: string;
	linksToShow: boolean = true;
	userId: number;
	//userId:number; //- Commenting the userId since the ManageAccountModel extends ResponseObject
	firstName: string;
	goPaperless: string;
	paperlessLink: string;
	appId: number;
	paperLessIndForUser: string;
	userRoleType: string;

	// me and My household
	messageCenter: boolean;
	changeReportErrorFlag: boolean;
	meAndMyHshldTbBn: MeAndMyHouseholdTab;
	theApplicantInfo: ApplicantInfo[] = [];

	//Dashboard
	logicalApplnId: string;
	paperLessFlag: string;
	paperlessY: string;
	paperlessN: string;
	remindMeLaterYn: string;
	doYouWantToGoPaperless: string;
	applnLockInd: string = "N";
	qhpActiveEnrollmentList: ActiveEnrollmentInfo[] = [];
	dntlActiveEnrollmentList: ActiveEnrollmentInfo[] = [];
	pcpEnabledInd: string = "N";
	loginUserRoles: string[];
	emailTx: string;
	verifyUploadDocPageFlag: string;
	verifyUploadDocPageUrl: string;
	isUserHasImportantActions: boolean = true;
	assistanceRequest: number;
	startApplnFlag: boolean;
	AssoPaperAppln: boolean;
	renewalRequiredFlag: boolean;
	inactiveApplnFlag: boolean;
	displayIndividualAcctBeanList: IndividualAcct[] = [];
	renewalTypeList: string[];
	isPureMedicaidAppln: string;
	renewalQHPYear: string;
	firstApplnId: string;
	firstApplnStatus: string;
	latestApplnId: string;
	latestApplnStatus: string;
	latestApplnType: string;
	previousApplnId: string;
	previousApplnStatus: string;
	completeApplnFlag: boolean;
	reportChangeFlag: boolean;
	continueReportChangeFlag: boolean;
	enrollCoverageFlag: boolean;
	twoApplnFlag: boolean;
	oneApplnFlag: boolean;
	mutiApplnFlag: boolean;

	// Expanded Message Center
	localAllMessages: ExpandedMessageCenter[] = [];
	years: number[] = [];
	dropdownMessageTypeList: any[] = [];
	dropdownMessageTypeListCP: any[] = [];
	dropdownMessageType: string;
	dropdownMessageTypeCP: string;
	dropdownMessageValue: string;
	messageType: number;
	year: number;

	//Assister
	messagesList: string[][];
	assitanceList: AssistanceAcct[];
	announcementsForAssisterHomePage: string[];
	assisterId: string;
	assterCertStatus: string;//R48 PT-19830 
	result: string;
	asstRelnId: string;
	documentId: string;

	// MyInbox
	applnIds: string[];
	missingInfoList: PersonMissingDocInfo[];
	sepVerfList: PersonMissingDocInfo[];
	step2MissingInfoList: PersonMissingDocInfo[];
	step3MissingInfoList: PersonMissingDocInfo[];
	//   missingInfoMap:{[key: string]: PersonMissingDocInfo[]};
	missingInfoListByDate: PersonMissingInfoListByDate[];
	userDocuments: MyInboxDocuments[];
	isUserInOpenPeriod: boolean;
	openEntrStartDate: string;
	openEntrEndDate: string;
	userChangeHistory: MessageCenter[];
	applnPresent: boolean;
	userIsInOpenPeriod: boolean;
	src: string;
	connectUrl: string;
	faqUrl: string;
	eligibilityDetExpired: boolean;
	loggedInAsUser: string;
	loggedInAsUserName: string;

	// R35: My Inbox => What you need to provide screen redesign
	prsnIdMissingVCLInfoMap: Map<number, PersonMissingDocInfo[]>;
	prsnIdNameMap: Map<number, string>;

	// R41: PT-17579
	subsidizedYN: string;
	nextYrPlanAvlMap: Map<string, string>;
	inOEPeriod: boolean;
	cctQckFlwInd: string;
	cctQckFlwDsplPlanId: string;
	displayQckLink:boolean;
	dsclmrIndCCT: string;
	hasPrimaryTaxFiler:boolean;
	navigatToICHRA :boolean = false;//R48 PT-20425
	ichraPortalUrl : string;//R48 PT-20425
	certInActive : boolean = false;
}
